module.exports = __webpack_public_path__ + "img/lock.718ae5b5.png";